import { UseQueryResult } from '@tanstack/react-query'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { parseRequestError } from '../../utilities'
import AppAlertComponent from '../AppAlertComponent/AppAlertComponent'
import LoadingCard from '../LoadingCard'

interface Props<TData> {
  query: UseQueryResult<TData, Error>
  children: (data: TData) => React.ReactNode
  customLoadingUI?: React.ReactNode
  customErrorUI?: (error: Error) => React.ReactNode
}

function PageLoader<TData>(props: Props<TData>) {
  const { query, children, customLoadingUI, customErrorUI } = props
  const { t: translate } = useTranslation()

  if (query.status === 'pending') {
    return customLoadingUI ? (
      <>{customLoadingUI}</>
    ) : (
      <LoadingCard isLoading={true}>{translate('loading')}</LoadingCard>
    )
  }

  if (query.status === 'error') {
    console.error(query.error)
    return customErrorUI ? (
      <>{customErrorUI(query.error)}</>
    ) : (
      <div className="max-w-xl mx-auto">
        <AppAlertComponent
          children={null}
          variant="error"
          title="Error"
          text={parseRequestError(query.error).message}
        ></AppAlertComponent>
      </div>
    )
  }

  return children(query.data as TData)
}

export default PageLoader